document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.amazon-buy-btn').forEach(button => {

    button.addEventListener('click', async function () {

      const data = {
        product_id: this.dataset.productId,
        product_title: this.dataset.productTitle,
        product_price: this.dataset.productPrice,
        amazon_link: this.dataset.amazonLink,
        timestamp: new Date().toISOString()
      };

      // Google Analytics Event
      if (typeof gtag !== 'undefined') {

        gtag('event', 'amazon_click', {
          product_id: data.product_id,
          product_name: data.product_title,
          value: data.product_price
        });

      }

      // Optional backend tracking
      try {

        await fetch('/apps/amazon-click-track', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

      } catch (err) {

        console.log('Tracking endpoint not connected yet');

      }

      // Redirect to Amazon
      window.location.href = data.amazon_link;

    });

  });

});